// extracted by mini-css-extract-plugin
module.exports = {"summary":"_1NsOciVc7-cogEuvM7KB93","row":"_2KwDYCX4fFChebNAN2wGTu"};